<template>
  <div>
    <div v-if="!loaded" v-html="info" :style="infoStyle" />
    <div v-else class="card flex-row" :style="cmptStyle">
      <!-- <div class="card-img-left" style="padding-top: 20px;">
        <img
          :src="formData.imgSrc"
          :alt="formData.title"
          style="width: 100%; height: auto;">
      </div> -->
      <div class="card-body">
        <h2 class="card-title">
          {{ formData.title }}
        </h2>
        <b-row>
          <b-col md="3">
            <h5 v-if="!formData.remote" class="card-subtitle text-muted">
              <b-icon icon="geo-alt"></b-icon>
              {{ formData.city }} / {{ formData.country }}
            </h5>
            <h5 v-else class="card-subtitle text-muted">
              <b-icon icon="geo-alt"></b-icon>
              remote
            </h5>
          </b-col>
          <b-col md="3">
            <h5 class="card-subtitle text-muted">
              <b-icon icon="briefcase"></b-icon>
              {{ formData.emplmntType }}
            </h5>
          </b-col>
          <b-col md="3">
            <h5 class="card-subtitle text-muted">
              <b-icon icon="calendar2-event"></b-icon>
              {{ formData.createDate.toLocaleDateString() }}
            </h5>
          </b-col>
          <b-col md="3">
            <h5 v-if="formData.salaryShow" class="card-subtitle text-muted">
              <b-icon icon="wallet2"></b-icon>
              {{ formData.salary }} / {{ formData.salaryUnit }}
            </h5>
          </b-col>
        </b-row>
        <br />
        <span class="card-text"
          v-html="json2HtmlFirstParagr(formData.descr)"></span>
        <div>
          <b-row>
            <b-col>
              <b-button>Mehr sehen</b-button>
            </b-col>
            <b-col>
              <b-button>Bewerben</b-button>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import config from '@/config'
import { json2Html } from '@/service/utils/ProsemirrorConverter'
import * as htmlUtil from '@/service/utils/html'
import { cwcComponent } from '@/components/content/mixins'

const DEFAULT_INFO_STYLE = { 'text-align': 'left', color: 'green' }

const ERROR_INFO_STYLE = { 'text-align': 'left', color: 'red' }

export default {
  name: 'comm-ad',
  version: '0.0.1',
  mixins: [cwcComponent],
  props: {
    contentKey: {
      type: String,
      required: true
    },
    genSeo: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      info: '... loading content!',
      infoStyle: DEFAULT_INFO_STYLE,
      /* Set to true if the content is loaded successfully, otherwise info is shown. */
      loaded: false,
      formData: {}
    }
  }, // data
  async mounted () {
    this.loaded = false
    try {
      const resp = await axios.get(config.glapiBaseUri + '/content/byContentKey/' +
        this.contentKey)

      const _contentData = resp.data.payload.content
      this.formData = _contentData.fragments
      this.formData.createDate = new Date(_contentData.createDate)
      if (this.genSeo && _contentData.jsonld) {
        htmlUtil.addJsonldToHead(_contentData.jsonld)
      }
      this.loaded = true
    } catch (e) {
      this.info = 'Error loading the content!'
      this.infoStyle = ERROR_INFO_STYLE
      this.loaded = false
      console.error('ERROR: Exception is: ', e)
    }
  }, // mounted
  methods: {
    json2Html,
    json2HtmlFirstParagr (descr) {
      const _descrRendered = this.json2Html(descr)
        return _descrRendered.substring(0, _descrRendered.indexOf('</p>') + 4)
    } // json2HtmlFirstParagr
  }
}
</script>

<style scoped>
/* .cmpn-text-short {
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  display:inline-block;
  width:150px;
} */

/* @import '~@mdi/font/css/materialdesignicons.min.css'; */
@import '~bootstrap/dist/css/bootstrap.css';
</style>
